import { useContext } from 'react'
import { UserContext } from 'utils/getContext'
import banner from "static/images/banner.png";

const NotLoggedIn = () => {
  const { loginInfo } = useContext(UserContext)
  // 点击前往登录
  const handleClick = () => {
    const { loginUrl, requestParams, appLoginReturnUrl } = loginInfo || {}
    const login = `${loginUrl}${requestParams}&${appLoginReturnUrl}`
    if (login) {
      window.location.href = login
    }
  };
  return (
    <div className="not-logged-in" onClick={handleClick}>
      <div className="not-logged-in-banner">
        <img src={banner} alt="banner" />
      </div>
    </div>
  );
};

export { NotLoggedIn };